import { render } from "./ConceptProfile.vue?vue&type=template&id=5d27ad40&scoped=true"
import script from "./ConceptProfile.vue?vue&type=script&lang=js"
export * from "./ConceptProfile.vue?vue&type=script&lang=js"

import "./ConceptProfile.vue?vue&type=style&index=0&id=5d27ad40&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d27ad40"]])

export default __exports__